var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PaymentErrorShortCodes, PaymentMethod } from './Interfaces/index.js';
import { PaymentSession } from './Session/index.js';
import { PaymentLegacySession } from './Legacy/Session/index.js';
import { BillingContact } from './BillingContact/index.js';
import { BillingMethodACH, BillingMethodCreditCard } from './BillingMethods/index.js';
import { BillingMethodECheck, BillingMethodEPaperToken } from './Legacy/BillingMethods/index.js';
import { PaymentClientError, PaymentValidationError } from './Errors/index.js';
import { PaymentErrorHandler } from './Session/PaymentErrorHandler.js';
// Load Vendor Modules
import { VendorModulesConfig } from './Configs/index.js';
import { PaymentCommunicator } from './Session/PaymentCommunicator.js';
import { PaymentAdapterIngenico, PaymentAdapterInicis } from './Adapters/index.js';
import { PaymentVendors } from './Interfaces/interface.adapter.js';
var PaymentClient = /** @class */ (function () {
    function PaymentClient(
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    init) {
        if (init === void 0) { init = {}; }
        this.paymentMethod = PaymentMethod.notPresent;
        if (!init.env) {
            throw new PaymentValidationError('Environment missing from initialization', PaymentErrorShortCodes.missing_env);
        }
        this.env = init.env;
        this.channel = init.channel;
        VendorModulesConfig.loadVendorModulesFiles();
        this.webDropInFailureCallback = function (message) {
            console.error('webDropInFailureCallback is not overriden, processPayment() was not called', message);
        };
        this.webDropInSuccessCallback = function (message) {
            console.error('webDropInSuccessCallback is not overriden, processPayment() was not called', message);
        };
        this.webComponentFailureCallback = function (message) {
            console.error('webComponentFailureCallback is not overriden, processPayment() was not called', message);
        };
        this.webComponentSuccessCallback = function (message) {
            console.error('webComponentSuccessCallback is not overriden, processPayment() was not called', message);
        };
    }
    PaymentClient.prototype.addSession = function (sessionId, sessionData, appName) {
        return __awaiter(this, void 0, void 0, function () {
            var isLegacyRequest;
            return __generator(this, function (_a) {
                this.sessionId = sessionId;
                this.appName = appName;
                isLegacyRequest = this.isLegacyRequest(this.sessionId);
                if (!isLegacyRequest) {
                    this.session = new PaymentSession({
                        sessionId: sessionId,
                        env: this.env,
                        appName: appName,
                        channel: this.channel
                    });
                }
                else {
                    if (!sessionData) {
                        throw new PaymentValidationError('Session Data Information is not present', PaymentErrorShortCodes.missing_session_data, { code: 'BG-2222' });
                    }
                    this.legacySession = new PaymentLegacySession(this.env, sessionId, sessionData);
                }
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addBillingContactInfo = function (billingContactInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.billingContactInfo = new BillingContact(billingContactInfo);
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addCreditCardInfo = function (cardInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.paymentMethod = PaymentMethod.creditCard;
                this.creditCardInfo = new BillingMethodCreditCard(cardInfo);
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addACHInfo = function (achInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.paymentMethod = PaymentMethod.ACH;
                this.achInfo = new BillingMethodACH(achInfo);
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addECheckInfo = function (eCheckInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.paymentMethod = PaymentMethod.eCheck;
                this.eCheckInfo = new BillingMethodECheck(eCheckInfo);
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addEPaperTokenInfo = function (ePaperTokenInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.paymentMethod = PaymentMethod.ePaperToken;
                this.ePaperTokenInfo = new BillingMethodEPaperToken(ePaperTokenInfo);
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addAgentAssistedInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.paymentMethod = PaymentMethod.agentAssisted;
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addThreeDSInfo = function (threeDSInfo) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.threeDSInfo = threeDSInfo;
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.addThreeDSecure = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var session, threeDSecurePayload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        session = this.validateSession();
                        return [4 /*yield*/, session.formatThreeDSecurePayload(payload)];
                    case 1:
                        threeDSecurePayload = _a.sent();
                        session.threeDSPayload = threeDSecurePayload;
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentClient.prototype.addWebDropIn = function (divId, paymentMethods) {
        return __awaiter(this, void 0, void 0, function () {
            var billingContactInfo, session, webDropInResponse;
            var _this = this;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        billingContactInfo = this.validateBillingContactInfo();
                        session = this.validateSession();
                        return [4 /*yield*/, session.getSessionInfo(billingContactInfo)];
                    case 1:
                        _c.sent();
                        // Default to credit card, the actual payment method will be chosen
                        // by the customer while completing the drop -in
                        this.paymentMethod = PaymentMethod.webDropInCreditCard;
                        this.vendorName = (_a = session.vendorSessionInfo) === null || _a === void 0 ? void 0 : _a.vendorName;
                        if (!(((_b = session.vendorSessionInfo) === null || _b === void 0 ? void 0 : _b.vendorName) == PaymentVendors.adyen)) return [3 /*break*/, 3];
                        // to satisfy typescript, webDropInSuccessCallback and webDropInFailureCallback are already initialized in the constructor with default values
                        if (!this.webDropInSuccessCallback || !this.webDropInFailureCallback) {
                            throw new Error('webDropInSuccessCallback or webDropInFailureCallback callbacks are not set');
                        }
                        return [4 /*yield*/, session.initializeWebDropIn(divId, paymentMethods, session.paymentCommunicator, function (success) {
                                if (_this.webDropInSuccessCallback) {
                                    _this.webDropInSuccessCallback(success);
                                }
                                else {
                                    console.error('webDropInSuccessCallback is not defined');
                                }
                            }, function (failure) {
                                if (_this.webDropInFailureCallback) {
                                    _this.webDropInFailureCallback(failure);
                                }
                                else {
                                    console.error('webDropInFailureCallback is not defined');
                                }
                            })];
                    case 2:
                        _c.sent();
                        return [2 /*return*/];
                    case 3: return [4 /*yield*/, session.initializeWebDropIn(divId, paymentMethods, session.paymentCommunicator)];
                    case 4:
                        webDropInResponse = _c.sent();
                        if (webDropInResponse) {
                            this.addEncryptedPayment(webDropInResponse);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentClient.prototype.addWebComponent = function (divId, paymentMethod) {
        return __awaiter(this, void 0, void 0, function () {
            var billingContactInfo, session;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        billingContactInfo = this.validateBillingContactInfo();
                        session = this.validateSession();
                        return [4 /*yield*/, session.getSessionInfo(billingContactInfo)];
                    case 1:
                        _a.sent();
                        // to satisfy typescript, webComponentSuccessCallback and webComponentFailureCallback are already initialized in the constructor with default values
                        if (!this.webComponentSuccessCallback || !this.webComponentFailureCallback) {
                            throw new Error('webComponentSuccessCallback or webComponentFailureCallback callbacks are not set');
                        }
                        return [4 /*yield*/, session.initializeWebComponent(divId, paymentMethod, session.paymentCommunicator, function (success) {
                                if (_this.webComponentSuccessCallback) {
                                    _this.webComponentSuccessCallback(success);
                                }
                                else {
                                    console.error('webComponentSuccessCallback is not defined');
                                }
                            }, function (failure) {
                                if (_this.webComponentFailureCallback) {
                                    _this.webComponentFailureCallback(failure);
                                }
                                else {
                                    console.error('webComponentFailureCallback is not defined');
                                }
                            })];
                    case 2:
                        _a.sent();
                        this.paymentMethod = paymentMethod;
                        return [2 /*return*/];
                }
            });
        });
    };
    PaymentClient.prototype.addEncryptedPayment = function (encryptedPaymentData) {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, isLegacyRequest, session, legacySession;
            return __generator(this, function (_a) {
                sessionId = this.validateSessionId();
                isLegacyRequest = this.isLegacyRequest(sessionId);
                if (!isLegacyRequest) {
                    session = this.validateSession();
                    session.encryptedPaymentData = encryptedPaymentData.encryptedPayment;
                }
                else {
                    legacySession = this.validateLegacySession();
                    legacySession.encryptedPaymentData = encryptedPaymentData.encryptedPayment;
                }
                this.paymentMethod = encryptedPaymentData.paymentMethod;
                return [2 /*return*/];
            });
        });
    };
    PaymentClient.prototype.encryptPayment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, isLegacyRequest, encryptedLegacyPayment, session, billingContactInfo, _a, creditCardInfo, encryptedCard, e_1, errorHandler, achInfo, encryptedACHData, e_2, errorHandler, eCheckInfo, encryptedData, e_3, errorHandler;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        sessionId = this.validateSessionId();
                        isLegacyRequest = this.isLegacyRequest(sessionId);
                        if (!isLegacyRequest) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.encryptLegacyPayment()];
                    case 1:
                        encryptedLegacyPayment = _b.sent();
                        return [2 /*return*/, encryptedLegacyPayment];
                    case 2:
                        session = this.validateSession();
                        billingContactInfo = this.validateBillingContactInfo();
                        _a = this.paymentMethod;
                        switch (_a) {
                            case PaymentMethod.creditCard: return [3 /*break*/, 3];
                            case PaymentMethod.ACH: return [3 /*break*/, 8];
                            case PaymentMethod.eCheck: return [3 /*break*/, 13];
                            case PaymentMethod.notPresent: return [3 /*break*/, 18];
                        }
                        return [3 /*break*/, 19];
                    case 3:
                        creditCardInfo = this.validateCreditCardInfo();
                        if (!creditCardInfo.nameOnCard) {
                            creditCardInfo.nameOnCard = BillingMethodCreditCard.formatNameOnCard("".concat(billingContactInfo.name.first, " ").concat(billingContactInfo.name.last));
                        }
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 7, , 8]);
                        return [4 /*yield*/, session.getSessionInfo(billingContactInfo)];
                    case 5:
                        _b.sent();
                        return [4 /*yield*/, session.encryptCreditCardData(creditCardInfo)];
                    case 6:
                        encryptedCard = _b.sent();
                        return [2 /*return*/, {
                                paymentMethod: PaymentMethod.creditCard,
                                encryptedPayment: encryptedCard
                            }];
                    case 7:
                        e_1 = _b.sent();
                        errorHandler = new PaymentErrorHandler();
                        errorHandler.logProcessingError(e_1, this, session.paymentCommunicator);
                        throw e_1;
                    case 8:
                        achInfo = this.validateACHInfo();
                        _b.label = 9;
                    case 9:
                        _b.trys.push([9, 12, , 13]);
                        return [4 /*yield*/, session.getSessionInfo(billingContactInfo)];
                    case 10:
                        _b.sent();
                        return [4 /*yield*/, session.encryptACHData(achInfo)];
                    case 11:
                        encryptedACHData = _b.sent();
                        return [2 /*return*/, {
                                paymentMethod: PaymentMethod.ACH,
                                encryptedPayment: encryptedACHData
                            }];
                    case 12:
                        e_2 = _b.sent();
                        errorHandler = new PaymentErrorHandler();
                        errorHandler.logProcessingError(e_2, this, session.paymentCommunicator);
                        throw e_2;
                    case 13:
                        eCheckInfo = this.validateECheckInfo();
                        _b.label = 14;
                    case 14:
                        _b.trys.push([14, 17, , 18]);
                        return [4 /*yield*/, session.getSessionInfo(billingContactInfo)];
                    case 15:
                        _b.sent();
                        return [4 /*yield*/, session.encryptEcheckData(eCheckInfo)];
                    case 16:
                        encryptedData = _b.sent();
                        return [2 /*return*/, {
                                paymentMethod: PaymentMethod.eCheck,
                                encryptedPayment: encryptedData
                            }];
                    case 17:
                        e_3 = _b.sent();
                        errorHandler = new PaymentErrorHandler();
                        errorHandler.logProcessingError(e_3, this, session.paymentCommunicator);
                        throw e_3;
                    case 18:
                        {
                            throw new PaymentValidationError('Payment Method is not present, make sure to add credit card info or other billing info', PaymentErrorShortCodes.missing_payment_method);
                        }
                        _b.label = 19;
                    case 19:
                        {
                            throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
                        }
                        _b.label = 20;
                    case 20: return [2 /*return*/];
                }
            });
        });
    };
    PaymentClient.prototype.processPayment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        switch (_this.paymentMethod) {
                            case PaymentMethod.webComponentPaypal:
                            case PaymentMethod.webComponentCreditCard:
                            case PaymentMethod.webComponentVirtualAccount:
                            case PaymentMethod.webComponentBankTransfer:
                            case PaymentMethod.webComponentCash:
                            case PaymentMethod.webComponentBoleto: {
                                _this.webComponentSuccessCallback = resolve;
                                _this.webComponentFailureCallback = reject;
                                break;
                            }
                            case PaymentMethod.webDropInCreditCard:
                            case PaymentMethod.webDropInPaypal: {
                                if ((_this === null || _this === void 0 ? void 0 : _this.vendorName) === PaymentVendors.adyen) {
                                    _this.webDropInSuccessCallback = resolve;
                                    _this.webDropInFailureCallback = reject;
                                    break;
                                }
                                var session = _this.validateSession();
                                session.paymentCommunicator
                                    .initiateWebDropInOrComponentChargeEvent(_this.paymentMethod, session.encryptedPaymentData)
                                    .then(function (webDropInResult) { return resolve(webDropInResult); })
                                    .catch(function (webDropInError) { return reject(webDropInError); });
                                break;
                            }
                            case PaymentMethod.agentAssisted: {
                                var session = _this.validateSession();
                                try {
                                    var result = session.processPayment('', _this.paymentMethod);
                                    resolve(result);
                                }
                                catch (e) {
                                    var errorHandler = new PaymentErrorHandler();
                                    errorHandler.logProcessingError(e, _this, session.paymentCommunicator);
                                    reject(e);
                                }
                                break;
                            }
                            default: {
                                // Encrypt using CSE
                                _this.getOrEncryptPaymentData().then(function (encryptedPaymentData) { return __awaiter(_this, void 0, void 0, function () {
                                    var billingContactInfo, threeDSInfo, sessionId, isLegacyRequest, legacySession, result, e_4, errorHandler, session, session, result, e_5, errorHandler;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                billingContactInfo = this.validateBillingContactInfo();
                                                threeDSInfo = this.validateThreeDSInfo();
                                                sessionId = this.validateSessionId();
                                                isLegacyRequest = this.isLegacyRequest(sessionId);
                                                if (!isLegacyRequest) return [3 /*break*/, 5];
                                                legacySession = this.validateLegacySession();
                                                _a.label = 1;
                                            case 1:
                                                _a.trys.push([1, 3, , 4]);
                                                return [4 /*yield*/, legacySession.processLegacyPayment(encryptedPaymentData.encryptedPayment)];
                                            case 2:
                                                result = _a.sent();
                                                resolve(result);
                                                return [3 /*break*/, 4];
                                            case 3:
                                                e_4 = _a.sent();
                                                errorHandler = new PaymentErrorHandler();
                                                session = new PaymentSession({
                                                    sessionId: sessionId,
                                                    env: this.env
                                                });
                                                errorHandler.logLegacyProcessingError(e_4, this, session.paymentCommunicator);
                                                reject(e_4);
                                                return [3 /*break*/, 4];
                                            case 4: return [3 /*break*/, 9];
                                            case 5:
                                                session = this.validateSession();
                                                _a.label = 6;
                                            case 6:
                                                _a.trys.push([6, 8, , 9]);
                                                return [4 /*yield*/, session.processPayment(encryptedPaymentData.encryptedPayment, encryptedPaymentData.paymentMethod, billingContactInfo, threeDSInfo)];
                                            case 7:
                                                result = _a.sent();
                                                resolve(result);
                                                return [3 /*break*/, 9];
                                            case 8:
                                                e_5 = _a.sent();
                                                errorHandler = new PaymentErrorHandler();
                                                errorHandler.logProcessingError(e_5, this, session.paymentCommunicator);
                                                reject(e_5);
                                                return [3 /*break*/, 9];
                                            case 9: return [2 /*return*/];
                                        }
                                    });
                                }); }, reject);
                            }
                        }
                    })];
            });
        });
    };
    PaymentClient.prototype.completePaymentSession = function (authId, isDefaultPaymentMethod) {
        return __awaiter(this, void 0, void 0, function () {
            var session, paymentResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        session = this.validateSession();
                        return [4 /*yield*/, session.completePaymentSession(authId, isDefaultPaymentMethod)];
                    case 1:
                        paymentResponse = _a.sent();
                        return [2 /*return*/, paymentResponse];
                }
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    PaymentClient.prototype.processVendorResponse = function (vendorResponse) {
        return __awaiter(this, void 0, void 0, function () {
            var vendorResponseObject, inicisMerchantData, paymentCommunicator, vendorResponseString, responseBody, response, e_6, errorHandler;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        vendorResponseObject = typeof vendorResponse === 'string' ? JSON.parse(vendorResponse) : vendorResponse;
                        inicisMerchantData = PaymentAdapterInicis.validateInicisVendorResponse(vendorResponseObject);
                        paymentCommunicator = new PaymentCommunicator({
                            env: this.env,
                            sessionId: inicisMerchantData.sessionId
                        });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        vendorResponseString = JSON.stringify(vendorResponseObject);
                        return [4 /*yield*/, paymentCommunicator.processPayment(vendorResponseString, inicisMerchantData.paymentMethod)];
                    case 2:
                        responseBody = _a.sent();
                        response = {
                            billingToken: responseBody.billingToken,
                            authId: responseBody.authId,
                            paymentId: responseBody.paymentId
                        };
                        return [2 /*return*/, response];
                    case 3:
                        e_6 = _a.sent();
                        errorHandler = new PaymentErrorHandler();
                        errorHandler.logProcessingError(e_6, this, paymentCommunicator);
                        throw e_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    PaymentClient.prototype.isLegacyRequest = function (sessionId) {
        return /^[SV][a-zA-Z0-9]{32}$/.test(sessionId);
    };
    PaymentClient.prototype.validateSessionId = function () {
        if (!this.sessionId) {
            throw new PaymentValidationError('Session Information is not present', PaymentErrorShortCodes.missing_session);
        }
        return this.sessionId;
    };
    PaymentClient.prototype.validateSession = function () {
        if (!this.session) {
            throw new PaymentValidationError('Session Information is not present', PaymentErrorShortCodes.missing_session);
        }
        return this.session;
    };
    PaymentClient.prototype.validateLegacySession = function () {
        if (!this.legacySession) {
            throw new PaymentValidationError('Session Information is not present', PaymentErrorShortCodes.missing_session);
        }
        return this.legacySession;
    };
    PaymentClient.prototype.validateBillingContactInfo = function () {
        if (!this.billingContactInfo) {
            throw new PaymentValidationError('Billing Contact Information is not present', PaymentErrorShortCodes.missing_billing_contact);
        }
        return this.billingContactInfo;
    };
    PaymentClient.prototype.validateCreditCardInfo = function () {
        if (!this.creditCardInfo) {
            throw new PaymentValidationError('Credit Card Information is not present', PaymentErrorShortCodes.missing_credit_card);
        }
        return this.creditCardInfo;
    };
    PaymentClient.prototype.validateACHInfo = function () {
        if (!this.achInfo) {
            throw new PaymentValidationError('ACH Information is not present', PaymentErrorShortCodes.missing_ach);
        }
        return this.achInfo;
    };
    PaymentClient.prototype.validateECheckInfo = function () {
        if (!this.eCheckInfo) {
            throw new PaymentValidationError('eCheck Information is not present', PaymentErrorShortCodes.missing_echeck);
        }
        return this.eCheckInfo;
    };
    PaymentClient.prototype.validateEPaperTokenInfo = function () {
        if (!this.ePaperTokenInfo) {
            throw new PaymentValidationError('ePaperToken Information is not present', PaymentErrorShortCodes.missing_epaper_token);
        }
        return this.ePaperTokenInfo;
    };
    PaymentClient.prototype.validateThreeDSInfo = function () {
        if (!this.threeDSInfo) {
            console.warn("validateThreeDSInfo found threeDSInfo wasn't set! This must be supplied in required regions. Not required here as not all regions require 3DS.");
        }
        else if (!this.threeDSInfo.acceptHeader ||
            !this.threeDSInfo.challengeWindowSize ||
            !this.threeDSInfo.colorDepth ||
            !this.threeDSInfo.culture ||
            // only validate this field for legacy (on prem) 3ds1 transactions. not used at all in 3ds2
            (!this.threeDSInfo.currency && this.legacySession) ||
            !this.threeDSInfo.ipAddress ||
            !this.threeDSInfo.javaEnabled ||
            !this.threeDSInfo.javaScriptEnabled ||
            // only validate this field for legacy (on prem) 3ds1 CC transactions. not used at all in 3ds2
            (!this.threeDSInfo.paymentProductId && this.legacySession && this.paymentMethod === PaymentMethod.creditCard) ||
            !this.threeDSInfo.screenHeight ||
            !this.threeDSInfo.screenWidth) {
            throw new PaymentValidationError('3DSecure information is not present. All fields must be supplied.', PaymentErrorShortCodes.missing_three_d_secure);
        }
        return this.threeDSInfo;
    };
    PaymentClient.prototype.encryptLegacyPayment = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, legacySession, billingContactInfo, _a, creditCardInfo, threeDSInfo, encryptedCardParams, e_7, errorHandler, session, achInfo, encryptedACHParams, e_8, errorHandler, session, eCheckInfo, encryptedECheckParams, e_9, errorHandler, session, ePaperTokenInfo, encryptedEPaperTokenParams, e_10, errorHandler, session;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        sessionId = this.validateSessionId();
                        legacySession = this.validateLegacySession();
                        billingContactInfo = this.validateBillingContactInfo();
                        if (this.threeDSInfo) {
                            // legacy CC is ALWAYS on ingenico and this method is already called in legacySession.encryptLegacyCreditCard
                            if (this.paymentMethod === PaymentMethod.creditCard && this.creditCardInfo) {
                                this.threeDSInfo.paymentProductId = PaymentAdapterIngenico.getOnPremPaymentProductId(this.creditCardInfo.number).toString();
                            }
                            // prefill this if available and missing
                            if (((_b = this.legacySession) === null || _b === void 0 ? void 0 : _b.sessionData.currency) && !this.threeDSInfo.currency) {
                                this.threeDSInfo.currency = (_c = this.legacySession) === null || _c === void 0 ? void 0 : _c.sessionData.currency;
                            }
                        }
                        _a = this.paymentMethod;
                        switch (_a) {
                            case PaymentMethod.creditCard: return [3 /*break*/, 1];
                            case PaymentMethod.ACH: return [3 /*break*/, 5];
                            case PaymentMethod.eCheck: return [3 /*break*/, 9];
                            case PaymentMethod.ePaperToken: return [3 /*break*/, 13];
                            case PaymentMethod.notPresent: return [3 /*break*/, 17];
                        }
                        return [3 /*break*/, 18];
                    case 1:
                        creditCardInfo = this.validateCreditCardInfo();
                        threeDSInfo = this.validateThreeDSInfo();
                        if (!creditCardInfo.nameOnCard) {
                            creditCardInfo.nameOnCard = BillingMethodCreditCard.formatNameOnCard("".concat(billingContactInfo.name.first, " ").concat(billingContactInfo.name.last));
                        }
                        _d.label = 2;
                    case 2:
                        _d.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, legacySession.encryptLegacyCreditCard(creditCardInfo, billingContactInfo, threeDSInfo)];
                    case 3:
                        encryptedCardParams = _d.sent();
                        return [2 /*return*/, {
                                paymentMethod: PaymentMethod.creditCard,
                                encryptedPayment: encryptedCardParams
                            }];
                    case 4:
                        e_7 = _d.sent();
                        errorHandler = new PaymentErrorHandler();
                        session = new PaymentSession({
                            sessionId: sessionId,
                            env: this.env,
                            appName: this.appName,
                            channel: this.channel
                        });
                        errorHandler.logLegacyProcessingError(e_7, this, session.paymentCommunicator);
                        throw e_7;
                    case 5:
                        achInfo = this.validateACHInfo();
                        _d.label = 6;
                    case 6:
                        _d.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, legacySession.encryptLegacyACH(achInfo, billingContactInfo)];
                    case 7:
                        encryptedACHParams = _d.sent();
                        return [2 /*return*/, {
                                paymentMethod: PaymentMethod.ACH,
                                encryptedPayment: encryptedACHParams
                            }];
                    case 8:
                        e_8 = _d.sent();
                        errorHandler = new PaymentErrorHandler();
                        session = new PaymentSession({
                            sessionId: sessionId,
                            env: this.env,
                            appName: this.appName,
                            channel: this.channel
                        });
                        errorHandler.logLegacyProcessingError(e_8, this, session.paymentCommunicator);
                        throw e_8;
                    case 9:
                        eCheckInfo = this.validateECheckInfo();
                        _d.label = 10;
                    case 10:
                        _d.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, legacySession.encryptLegacyECheck(eCheckInfo, billingContactInfo)];
                    case 11:
                        encryptedECheckParams = _d.sent();
                        return [2 /*return*/, {
                                paymentMethod: PaymentMethod.eCheck,
                                encryptedPayment: encryptedECheckParams
                            }];
                    case 12:
                        e_9 = _d.sent();
                        errorHandler = new PaymentErrorHandler();
                        session = new PaymentSession({
                            sessionId: sessionId,
                            env: this.env,
                            appName: this.appName,
                            channel: this.channel
                        });
                        errorHandler.logLegacyProcessingError(e_9, this, session.paymentCommunicator);
                        throw e_9;
                    case 13:
                        ePaperTokenInfo = this.validateEPaperTokenInfo();
                        _d.label = 14;
                    case 14:
                        _d.trys.push([14, 16, , 17]);
                        return [4 /*yield*/, legacySession.encryptLegacyEPaperToken(ePaperTokenInfo, billingContactInfo)];
                    case 15:
                        encryptedEPaperTokenParams = _d.sent();
                        return [2 /*return*/, {
                                paymentMethod: PaymentMethod.ePaperToken,
                                encryptedPayment: encryptedEPaperTokenParams
                            }];
                    case 16:
                        e_10 = _d.sent();
                        errorHandler = new PaymentErrorHandler();
                        session = new PaymentSession({
                            sessionId: sessionId,
                            env: this.env,
                            appName: this.appName,
                            channel: this.channel
                        });
                        errorHandler.logLegacyProcessingError(e_10, this, session.paymentCommunicator);
                        throw e_10;
                    case 17:
                        {
                            throw new PaymentValidationError('Payment Method is not present, make sure to add credit card info or other billing info', PaymentErrorShortCodes.missing_payment_method);
                        }
                        _d.label = 18;
                    case 18:
                        {
                            throw new PaymentClientError('Payment Method is not supported', PaymentErrorShortCodes.unsupported_payment_method);
                        }
                        _d.label = 19;
                    case 19: return [2 /*return*/];
                }
            });
        });
    };
    PaymentClient.prototype.getOrEncryptPaymentData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var sessionId, isLegacyRequest, legacySession, session, encryptedPaymentData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        sessionId = this.validateSessionId();
                        isLegacyRequest = this.isLegacyRequest(sessionId);
                        if (isLegacyRequest) {
                            legacySession = this.validateLegacySession();
                            if (legacySession.encryptedPaymentData) {
                                return [2 /*return*/, {
                                        paymentMethod: this.paymentMethod,
                                        encryptedPayment: legacySession.encryptedPaymentData
                                    }];
                            }
                        }
                        else {
                            session = this.validateSession();
                            if (session.encryptedPaymentData) {
                                return [2 /*return*/, {
                                        paymentMethod: this.paymentMethod,
                                        encryptedPayment: session.encryptedPaymentData
                                    }];
                            }
                        }
                        return [4 /*yield*/, this.encryptPayment()];
                    case 1:
                        encryptedPaymentData = _a.sent();
                        return [2 /*return*/, encryptedPaymentData];
                }
            });
        });
    };
    return PaymentClient;
}());
export { PaymentClient };
